/**
 * Created by RKL on 21/08/2015.
 */
define('personalizeShowController',[
  'module',
  'logger',
  'underscore',
  'app',
  'personalizeShowView',
  'settings'
], function(
  module,
  Logger,
  _,
  App,
  View
) {
  'use strict';

  var PersonalizeController = {
    showPersonalize: function() {
      var view = new View();

      App.regions.getRegion('main').currentView.getRegion('content').show(view);
    }
  };

  module.exports = PersonalizeController;
});
